import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { AuthContext } from './AuthContext';
import { clearStoredAuthToken, readAuthToken } from '../../services/api';

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, authLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  const [allowRender, setAllowRender] = useState(false);

  useEffect(() => {
    if (authLoading) {
      return;
    }

    const token = readAuthToken();
    if (!token) {
      navigate('/login');
      setAllowRender(false);
      return;
    }

    if (!user) {
      clearStoredAuthToken();
      navigate('/login');
      setAllowRender(false);
      return;
    }

    if (requireAdmin && user.userType !== 'admin') {
      navigate('/', { replace: true });
      setAllowRender(false);
      return;
    }

    setAllowRender(true);
  }, [authLoading, user, navigate, requireAdmin]);

  if (authLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#9aa4bf',
      }}
      >
        Loading...
      </div>
    );
  }

  if (!allowRender) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
